import styled from "@emotion/styled";
import IconButton from "@mui/material/IconButton";
import { COLOR_BLACK_80, COLOR_WHITE } from "shared/theme/colors";

export const StyledImageContainer = styled.div`
  position: relative;
  width: fit-content;
`;

export const StyledImageActionContainer = styled.div`
  position: absolute;
  bottom: 2px;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${COLOR_BLACK_80};
  width: 100%;
  border-bottom-left-radius: 1rem;
  border-bottom-right-radius: 1rem;
`;

export const StyledImageButton = styled(IconButton)`
  padding: 0.2rem 0.5rem;
`;

export const StyledImageActionText = styled.div`
  padding: 0.5rem;
  color: ${COLOR_WHITE};
  font-size: 12px;
  font-weight: 500;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;
